module.exports = __webpack_public_path__ + "img/t3-7.93e8902f.png";